import makeTable from "./makeTable";
import BASE_WIDTH_COLUMNS from "./constants/baseWidthColumns";

const { COMPANIES, BALANCE, TAXI_SERVICE, NAME } = BASE_WIDTH_COLUMNS;

export enum ColumnId {
	Name = "name",
	CarPark = "carPark",
	Balance = "balance",
	BonusBalance = "bonusBalance",
	CommissionPlans = "commissionPlans",
	BalanceType = "balanceType",
	Company = "company",
	TaxiService = "taxiService",
}

export const translationTablePath = "settings.carParks.general.columns.";

const settingsCarParksGeneral = makeTable({
	allIds: [
		ColumnId.Name,
		ColumnId.CarPark,
		ColumnId.Balance,
		ColumnId.BonusBalance,
		ColumnId.CommissionPlans,
		ColumnId.BalanceType,
		ColumnId.Company,
		ColumnId.TaxiService,
	],
	i18tPath: (id) => `${translationTablePath}${id}`,
	defaultIds: [
		ColumnId.Name,
		ColumnId.CarPark,
		ColumnId.Balance,
		ColumnId.BonusBalance,
		ColumnId.CommissionPlans,
		ColumnId.BalanceType,
		ColumnId.Company,
		ColumnId.TaxiService,
	],
	initialSortMethod: {
		column: ColumnId.Name,
		type: "asc",
	},
	initialWidths: {
		[ColumnId.Name]: NAME,
		[ColumnId.CarPark]: NAME,
		[ColumnId.Balance]: BALANCE,
		[ColumnId.BonusBalance]: BALANCE,
		[ColumnId.CommissionPlans]: 250,
		[ColumnId.BalanceType]: 170,
		[ColumnId.Company]: COMPANIES,
		[ColumnId.TaxiService]: TAXI_SERVICE,
	},
	initialResizable: {
		[ColumnId.Name]: true,
		[ColumnId.CarPark]: true,
		[ColumnId.Balance]: true,
		[ColumnId.BonusBalance]: true,
		[ColumnId.CommissionPlans]: true,
		[ColumnId.BalanceType]: true,
		[ColumnId.Company]: true,
		[ColumnId.TaxiService]: true,
	},
	initialSortable: {
		[ColumnId.Name]: true,
		[ColumnId.CarPark]: true,
		[ColumnId.Balance]: true,
		[ColumnId.BonusBalance]: true,
		[ColumnId.CommissionPlans]: true,
		[ColumnId.BalanceType]: true,
		[ColumnId.Company]: true,
		[ColumnId.TaxiService]: true,
	},
});

export default settingsCarParksGeneral;
